import { render } from "./addressSelection.vue?vue&type=template&id=31f8c326"
import script from "./addressSelection.vue?vue&type=script&lang=js"
export * from "./addressSelection.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/_vue-loader@17.4.2@vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__